import { Reveal } from "@/components/Reveal";
import Icon from "@/components/Icon";
import { DIFFERENTIALS } from "@/data/site";

export default function Differentials() {
  return (
    <section className="relative overflow-hidden bg-neutral-100 py-24 md:py-32" data-testid="differentials">
      <div className="relative mx-auto max-w-7xl px-5 md:px-8">
        <Reveal className="mb-14 text-center">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-brand-red">Diferenciais</p>
          <h2 className="mt-4 font-display text-4xl uppercase leading-[0.95] tracking-tight text-brand-obsidian md:text-6xl">
            Por que escolher a Pimenta
          </h2>
        </Reveal>

        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-sm border border-black/10 bg-black/10 md:grid-cols-4">
          {DIFFERENTIALS.map((d, i) => (
            <Reveal key={d.title} delay={(i % 4) * 0.05}>
              <div className="group flex h-full flex-col items-start gap-4 bg-white p-6 transition-colors duration-300 hover:bg-neutral-50 md:p-8">
                <Icon name={d.icon} weight="duotone" className="h-10 w-10 text-brand-red transition-transform duration-300 group-hover:scale-110" />
                <h3 className="font-heading text-base font-semibold uppercase leading-tight tracking-wide text-brand-obsidian">{d.title}</h3>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
